import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { afterItems, beforeItems, transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section className="bg-brand-paper px-4 py-20 md:py-28" data-id="element-154" data-mp="2ww2p8roo2zvm">
      <Reveal className="mx-auto max-w-5xl" data-id="element-155" data-mp="2rz2kql7gu56m">
        <div className="mx-auto max-w-3xl text-center" data-id="element-156" data-mp="2ryayi0zrdjt0">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-sageInk" data-id="element-157" data-mp="2nx7hhb5z5hq7">
            UNE MEILLEURE FAÇON D&apos;ENSEIGNER LE REFORMER
          </p>
          <h2 className="text-4xl font-black leading-[1.08] tracking-tight text-brand-slate md:text-5xl" data-id="element-158" data-mp="2e75t0i9plxar">
            D&apos;un professeur débordé par la préparation à un{' '}
            <span className="italic text-brand-terracottaInk" data-id="element-159" data-mp="299w4d4u59pnz">enseignement structuré et sûr sur le Reformer.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-160" data-mp="207d9b6wlohca">
            Chaque professeur de Pilates Reformer connaît ce moment : le dimanche soir, sans idée claire de ce qu&apos;il
            va enseigner lundi, en train d&apos;improviser une séquence à partir de souvenirs de formation. Pilates
            Reformer Prêt™️ remplace cette improvisation par une progression déjà construite, niveau par niveau, prête à
            ouvrir et à suivre.
          </p>
        </div>
        <div className="mx-auto my-12 grid max-w-3xl divide-y divide-brand-sand overflow-hidden rounded-2xl border border-brand-sand bg-white shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-161" data-mp="y121ra9zea83">
          {transformationStats.map(([value, label]) => <div key={label} className="px-5 py-5 text-center" data-id="element-162" data-mp="p2yhehaqfjhv">
              <strong className="block font-serif text-3xl leading-none text-brand-terracottaInk" data-id="element-163" data-mp="t1603horauvp">{value}</strong>
              <span className="mt-2 block text-[10px] font-extrabold leading-tight tracking-[0.08em] text-brand-gray" data-id="element-164" data-mp="39pjmlhf7bhci">
                {label}
              </span>
            </div>)}
        </div>
        <div className="overflow-hidden rounded-3xl border border-brand-sand bg-white shadow-[0_18px_45px_rgba(44,62,80,0.10)]" data-id="element-165" data-mp="1k97j70kjnlxr">
          <div className="grid md:grid-cols-2" data-id="element-166" data-mp="1ak63lbhwv6kb">
            <Comparaison title="AVANT" items={beforeItems} positive={false} data-id="element-167" data-mp="1aiv07csdo0tq" />
            <Comparaison title="AVEC PILATES REFORMER PRÊT" items={afterItems} positive data-id="element-168" data-mp="15luvp6b6f64q" />
          </div>
          <div className="border-t border-brand-sand bg-brand-sandSoft px-6 py-4 text-center text-xs font-semibold text-brand-gray" data-id="element-169" data-mp="11jrf639nhbcl">
            Une progression complète qui prépare la séance à votre place et vous fait entrer en studio sereinement.
          </div>
        </div>
      </Reveal>
    </section>;
}
function Comparaison({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckCircle2Icon : XCircleIcon;
  return <div className={`p-6 md:p-9 ${positive ? 'border-t border-brand-sand bg-white md:border-l md:border-t-0' : 'bg-brand-sand'}`} data-id="element-170" data-mp="2gzqcejhqbmy2">
      <div className="mb-7 flex items-start justify-between gap-4" data-id="element-171" data-mp="2ph0ce93q998j">
        <div data-id="element-172" data-mp="2thsmf4kfbi5v">
          <p className={`text-[10px] font-extrabold tracking-[0.16em] ${positive ? 'text-brand-sageInk' : 'text-brand-gray'}`} data-id="element-173" data-mp="2thj505dg2jbs">
            {positive ? "LE SYSTÈME PRÊT À L'EMPLOI" : "L'ANCIENNE FAÇON DE PRÉPARER SES COURS"}
          </p>
          <h3 className="mt-2 font-serif text-2xl font-bold tracking-tight text-brand-slate" data-id="element-174" data-mp="26io4srsgs7f2">{title}</h3>
        </div>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-sage text-white shadow-md' : 'bg-white text-brand-gray'}`} data-id="element-175" data-mp="2aj81ju94l90o">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-176" data-mp="2kifmp3m3q7yc" />
        </div>
      </div>
      <ul className="space-y-2.5" data-id="element-177" data-mp="3qyhw1kfm7opt">
        {items.map(item => <li key={item} className={`flex items-center gap-3 rounded-xl px-3 py-3 ${positive ? 'bg-brand-sandSoft' : 'bg-white/70'}`} data-id="element-178" data-mp="3r0c623pclwf4">
            <Icon className={`h-4 w-4 shrink-0 ${positive ? 'text-brand-sageInk' : 'text-brand-gray'}`} aria-hidden="true" data-id="element-179" data-mp="18pofvgo429i4" />
            <span className={`text-sm leading-snug ${positive ? 'font-semibold text-brand-text' : 'text-brand-gray'}`} data-id="element-180" data-mp="1hq334lkmxyo9">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}